var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userAgent && !_vm.isInstagramBrowser)?_c('div',{staticClass:"share-button",on:{"click":_vm.handleShareClick}},[_c('img',{attrs:{"src":require("@/assets/icons/share.svg"),"alt":"share"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }